export default "__VITE_ASSET__DT6x_Uy2__"